//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'

export default Vue.extend({
  name: 'HomeIcon',
  props: {
    fillColor: {
      type: String,
      required: false,
      default: '',
    },
  },
})
